import { devices } from '@helpers/utils.js';

const {
  i18n: { __ },
  components: { PanelBody, ColorPalette },
} = wp;

const BackgroundTypeColor = ({ backgroundColorOptions, setAttributes }) => {
  const colors = wp.data.select('core/block-editor').getSettings().colors;

  const onChangeBackgroundColor = (
    paramValue,
    paramDeviceType,
    paramBackgroundColorOptions,
    paramBackgroundColor,
  ) => {
    setAttributes({
      backgroundColorOptions: {
        ...paramBackgroundColorOptions,
        [paramDeviceType]: {
          ...backgroundColorOptions[paramDeviceType],
          settings: {
            ...paramBackgroundColorOptions[paramDeviceType].settings,
            [paramBackgroundColor]: paramValue,
          },
        },
      },
    });
  };

  return (
    <>
      {devices.map((device, index) => {
        const deviceType = device.type;
        const deviceLabel = device.label;
        return (
          <PanelBody
            title={deviceLabel}
            initialOpen={index === 0}
            key={deviceType}
          >
            <ColorPalette
              label={__('Select Background Color', 'b3rg')}
              colors={colors}
              enableAlpha
              value={
                backgroundColorOptions[deviceType].settings.backgroundColor
              }
              onChange={(newValue) => {
                onChangeBackgroundColor(
                  newValue,
                  deviceType,
                  backgroundColorOptions,
                  'backgroundColor',
                );
              }}
            />
          </PanelBody>
        );
      })}
    </>
  );
};

export default BackgroundTypeColor;
